<!--
 * @Author: zs
 * @Date: 2022-04-21 15:35:01
 * @LastEditTime: 2022-06-13 14:49:05
 * @Description: 新增、编辑、详情等使用锚点展示
 * @FilePath: \smart-community\src\components\formDetail\PersonneComponent.vue
-->
<template>
  <div class="HAnchor">
    <div class="left">
      <ul>
        <li
          :class="[show == index ? 'item1' : 'item']"
          @click="change(item.id, index)"
          v-for="(item, index) in idList"
          :key="index"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="leftz"></div>
    <div class="right" id="pop">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
  onUnmounted,
} from "vue-demi";

export default defineComponent({
  name: "HAnchor",
  components: {},
  props: {
    userlist: {
      type: Array,
      required: true,
    },
    idList: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      stateTop: 0,
      s: 0,
      show: 0,
      titleIndex: 0,
      scrollBottom: false,
      scrollBottomIndex: 0, // 最底下的dom处在锚点第几个
    });
    const refData = toRefs(state);
    // 位移
    const change = (id, index) => {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    };
    watchEffect(() => {
      state.show = 0;
    });
    const scrollC = () => {
      if (document.getElementById("pop")) {
        state.s = document.getElementById("pop").scrollTop || 0;
        const arr = [];
        props.idList.forEach((item) => {
          const offtop =
            document.getElementById(item.id) &&
            document.getElementById(item.id).offsetTop;
          arr.push(offtop);
        });
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (state.s <= element) {
            state.show = index;
            break;
          }
        }
      }
    };
    onMounted(() => {
      window.addEventListener("scroll", scrollC, true);
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", scrollC);
    });
    return {
      ...refData,
      change,
    };
  },
});
</script>

<style lang="scss" scoped>
.HAnchor {
  width: 100%;
  display: flex;
  .left {
    // position: fixed;
    // top: 160px;
    ul {
      .item {
        box-shadow: 0 0 2px;
        cursor: pointer;
        margin: 30px 0;
        border: solid 1px #dcdfe6;
        width: 110px;
        line-height: 50px;
        text-align: center;
        display: flex;
        flex-direction: column;
        border-radius: 5px;
      }
      .item1 {
        border-radius: 5px;
        box-shadow: 0 0 2px;
        color: #3a74fb;
        cursor: pointer;
        margin: 30px 0;
        border: solid 1px #3a74fb;
        border-left: solid 5px #3a74fb;
        width: 110px;
        line-height: 50px;
        text-align: center;
        display: flex;
        flex-direction: column;
      }
    }
  }
  // .leftz {
  //   height: 100%;
  //   width: 14%;
  //   min-width: 120px;
  //   border-right: 1px solid #eeeeee;
  // }
  .right {
    overflow: auto;
    width: 84%;
    padding-left: 1%;
    margin-left: 1%;
    cursor: default;
    border-left: 1px solid #eeeeee;
    .information {
      margin-bottom: 30px;
      ul {
        display: flex;
        flex-wrap: wrap;
        margin-top: -20px;
        li {
          font-size: 15px;
          min-width: 50%;
          margin: 10px 0;
          .color {
            color: #888;
          }
          span {
            color: #333;
          }
        }
      }
    }
    .information:last-child {
      height: 500px;
    }
  }
}
</style>